import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Paper, useMediaQuery, useTheme } from '@mui/material';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useI18n } from '../../i18n';

/** 모바일 디앱 하단 탭 — 송금·프로필·가이드·소개 */
export default function DappMobileNav() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useI18n();

  if (!isMobile) return null;

  const path = location.pathname;
  let value = 'transfer';
  if (path.startsWith('/profile')) value = 'profile';
  else if (path.startsWith('/guide')) value = 'guide';
  else if (path === '/') value = 'home';

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: theme.zIndex.appBar,
        borderTop: 1,
        borderColor: 'divider',
        pb: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <BottomNavigation
        value={value}
        onChange={(_, v) => {
          if (v === 'home') navigate('/');
          else if (v === 'guide') navigate('/guide');
          else if (v === 'profile') navigate('/profile');
          else navigate('/transfer');
        }}
        showLabels
      >
        <BottomNavigationAction label={t('nav.intro')} value="home" icon={<HomeOutlinedIcon />} />
        <BottomNavigationAction label={t('nav.transfer')} value="transfer" icon={<SendOutlinedIcon />} />
        <BottomNavigationAction label={t('nav.profile')} value="profile" icon={<PersonOutlineIcon />} />
        <BottomNavigationAction label={t('nav.help')} value="guide" icon={<MenuBookOutlinedIcon />} />
      </BottomNavigation>
    </Paper>
  );
}
